import { useRouter } from 'next/router';
import Head from 'next/head';
import { getFreeMovie } from 'api/index';
import Nav from '@/components/modules/Nav/Nav';
import PornHubLayout from '@/components/layouts/PornHubLayout/PornHubLayout';
import VideoPlayer from '@/components/elements/VideoPlayer/VideoPlayer';
import Button from '@/components/elements/Button/Button';
import SingleTestimonial from '@/components/modules/SingleTestimonial/SingleTestimonial';
import styles from '../../styles/FreeMovie.module.scss';

const testimonial = {
    quote: <><b>“I&#39;m finding the power in my own skin precisely because I can find my own pleasure.”</b> - Sabrina</>,
    img: "Kaitlyn Testimonial.webp",
    color: "blueDark"
}

export default function FreeMovie({video}){

    const router = useRouter();

    return (
        <>
            <Head>
                <title>Free Movie | afterglow</title>
                <link rel="stylesheet"  href="https://cdn.fluidplayer.com/v2/current/fluidplayer.min.css" type="text/css"  />
            </Head>
            <PornHubLayout>
               <main className={styles.freeMovie}>
                   <div className={styles.headerTexts}>
                       <h1>This is what porn should be like</h1>
                       <div className={styles.categories}>
                            <div className={styles.category}>ethical porn</div>
                            <div className={styles.dot}></div>
                            <div className={styles.category}>guided masturbations</div>
                            <div className={styles.dot}></div>
                            <div className={styles.category}>made by women</div>
                       </div>
                   </div>
                   <div className={styles.video}>
                        <VideoPlayer video={video} />
                   </div>
                   <div className={styles.cta}>
                        <Button theme="blue" onClick={()=>router.push("/signup")}>Join Now</Button>
                   </div>
                   <div className={styles.testimonial}>
                        <SingleTestimonial testimonial={testimonial} />
                   </div>
               </main>
            </PornHubLayout>
        </>
    )
}

export async function getServerSideProps(context) {
    const slug = context.params.slug;
    const [freeMovieRes] = await Promise.allSettled([getFreeMovie(slug)]);
    return {
        props: { 
            slug,
            video: freeMovieRes.value.data,
        },
    }
}


FreeMovie.Nav = <Nav dark={true} noTabs={true} /> 
FreeMovie.Footer = false
FreeMovie.BodyScripts = <>
    <script src="https://cdn.jsdelivr.net/npm/hls.js@latest"></script>
    <script src="https://cdn.fluidplayer.com/v2/current/fluidplayer.min.js" />
</>